<h1 mat-dialog-title>Kreiranje vrste zadatka</h1>
<div [formGroup]="form" mat-dialog-content>
    <mat-form-field>
        <mat-label>Unesite vrstu zadatka</mat-label>
        <input placeholder="Unesite vrstu zadatka"
               matInput text
               required
               formControlName="name"
               pattern="\S+.*"
               [(ngModel)]="task">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="close()">Otkaži</button>
    <button mat-button style="float: right" (click)="save()">Sačuvaj</button>
</div>


